import { Fragment, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __MANAGEMENT_API_URL__, __TOPONYMY_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { useEffect } from 'react';
import { noop } from 'shell/utils/noop';
import { Service } from 'shell/models/service';
import FormService, { ServiceForm } from 'system/components/services/form';
// import ListServiceOperator from 'system/components/services/operators';
// import ListExhibiting from 'system/components/services/exhibiting';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonServiceCrumbs } from '../constants';
import { CirculationArea } from 'shell/models/circulation-area';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import {
  transformerService,
  transformerTownHall,
} from 'system/components/services/utils/transformer-service';
import { transformerCirculationArea } from 'system/components/services/utils/transformer-circulation-area';
import { MunicipalityVM } from 'system/view-models/municipality';
import { CirculationAreaClient } from 'shell/view-models/circulation-area-client';

const ServiceDetailPage = (): React.ReactElement => {
  const params = useParams();

  const [service, getService] = useHttpFetch<HttpResponse<Service>, ServiceForm>(
    `${__MANAGEMENT_API_URL__}/servizi/${params.id}`,
    {
      onBootstrap: false,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformerService,
    }
  );

  const [townHall, getTownHall] = useHttpFetch(`${__TOPONYMY_API_URL__}/municipi`, {
    onBootstrap: false,
    options: {
      errorCatching: true,
      method: 'GET',
      loading: true,
      data: {},
    },
    transformer: transformerTownHall,
  });

  const [circulationArea, getCirculationArea] = useHttpFetch<
    HttpResponse<CirculationArea>,
    CirculationAreaClient
  >(`${__TOPONYMY_API_URL__}/areaCircolazione`, {
    onBootstrap: false,
    options: {
      errorCatching: true,
      method: 'GET',
      loading: true,
      data: {},
    },
    transformer: transformerCirculationArea,
  });

  const serviceInitialValues: ServiceForm = useMemo(() => {
    if (!service.data) {
      return {
        code: '',
        name: '',
        streetNumber: '',
        shortDescription: '',
        phoneNumber: '',
        area: null,
        type: '',
        civicRepresentative: '',
        contextLastUpdate: '',
        zone: null,
      };
    }

    return {
      ...(service.data as ServiceForm),
      area: circulationArea.data as CirculationAreaClient,
      zone: townHall.data as MunicipalityVM,
    };
  }, [service.data, circulationArea.data, townHall.data]);

  const navigate = useNavigate();

  useEffect(() => {
    getService();
    const castGetService = getService() as ResponsePromise<HttpResponse<Service>, ServiceForm>;
    castGetService.then((response) => {
      const responseService = response as ServiceForm;

      if (responseService.zoneCode) {
        getTownHall({
          url: `/${responseService.zoneCode}`,
        });
      }

      if (responseService?.areaCircolazione) {
        getCirculationArea({
          url: `/${responseService?.areaCircolazione?.toString()}`,
        });
      }
    });
  }, [params.id]);

  const loadCirculationArea = serviceInitialValues.areaCircolazione
    ? circulationArea.isLoading || circulationArea.pristine || circulationArea.hasErrors
    : false;

  const loadingService =
    service.isLoading || service.pristine || service.hasErrors || loadCirculationArea;

  return (
    <Fragment>
      <Breadcrumbs
        items={[
          ...CommonServiceCrumbs,
          {
            name: 'Dettaglio Servizio',
          },
        ]}
      />
      {loadingService ? null : (
        <FormService
          title="Dettaglio Servizio"
          onOk={noop}
          onCancel={() => {
            navigate('/sistema/servizi');
          }}
          disabled
          initialValues={serviceInitialValues}
        >
          {/* <ListServiceOperator
            onDetailPress={onDetailPress}
            onEditPress={onEditPress}
            serviceId={serviceInitialValues.code || ''}
          />
          <ListExhibiting serviceId={serviceInitialValues.code || ''} /> */}
        </FormService>
      )}
    </Fragment>
  );
};

ServiceDetailPage.displayName = 'Service Detail page component';

export default ServiceDetailPage;
